<template>
  <div>
    {{ item.ref_description }}
    <!-- <div class="stable">
      <div class="srow">
        <div class="scell result-term">{{ item.ref_description }}</div> -->
        <!-- <div class="scell result-ref">{{ item.ref_number }}</div>
        <div class="scell result-img"><img :src=" getBaseUrl + getImgUrl + item.ref_image " alt=""></div>
        <div :class="'scell box bg-'+ item.lin_name.toLowerCase()">{{ item.lin_name.substring(0, 1) }}</div>   -->      
    <!--   </div>
    </div> -->
    <!-- <b>#{{item.ref_number}}</b>
    <span>{{ item.lin_name }}</span>
    <abbr>{{item.ref_description}}</abbr> -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  props: {
    item: { required: true },
    searchText: { required: true }
  },
  computed: {	
      ...mapGetters( ['getApiUrl', 'getBaseUrl', 'getImgUrl'] ),		
    },
}
</script>